module.exports = __webpack_public_path__ + "img/nota-folio-ahued.9643fdb6.png";